export default {
  namespaced: false,

  state: {
    team: {
      address: null,
      billing_email: null,
      billing_first_name: null,
      billing_last_name: null,
      city: null,
      company_name: null,
      country_id: null,
      id: null,
      phone_number: null,
      postal_code: null,
      state: null,
      tax_id: null,
    },
  },
  mutations: {

    TEAM_DETAILS_SET_TEAM: (state, payload) => {
      state.team = { ...payload };
    },
  },
  actions: {
    teamDetailsSetTeam({ commit }, payload) {
      commit('TEAM_DETAILS_SET_TEAM', payload);
    },
  },
};
